import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import Typography from 'Components/UI/Typography';
import { OnboardingPlannerViewProvider } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/ViewContext';
import ViewContainer
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/ViewContainer';

const ViewPicker = ({ householdResource, ...rest }) => {
  return pickFunction(householdResource, {
    [fr.relationships.onboardingPlannerView.name]: () => {
      return (
        <OnboardingPlannerViewProvider householdResource={householdResource}>
          <ViewContainer
            {...rest}
          />
        </OnboardingPlannerViewProvider>
      );
    },
    [fr.relationships.default.name]: () => {
      return <Typography variant="h2" align="center">This feature is currently in development</Typography>;
    },
  });
};

export default ViewPicker;
